import React from 'react';
import { CHART_COLORS } from '../constants';
import { formatCurrency } from '../helpers';
import styles from '../summary.module.scss';

const RankingTable = ({ data, entityLabel = 'Cliente' }) => {
  const maxTotal = data[0]?.total || 1;

  return (
    <div className={styles.tableWrap}>
      <table className={styles.dataTable}>
        <thead>
          <tr>
            <th className={styles.colRank}>#</th>
            <th className={styles.colName}>{entityLabel}</th>
            <th className={styles.colValue}>Venta</th>
            <th className={styles.colBar}></th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            const pct = (item.total / maxTotal) * 100;
            const color = CHART_COLORS[index % CHART_COLORS.length];
            return (
              <tr key={item.name} className={styles.dataRow}>
                <td className={styles.cellRank}>
                  <span className={styles.rankBadge} style={{ backgroundColor: color }}>
                    {index + 1}
                  </span>
                </td>
                <td className={styles.cellName}>{item.name}</td>
                <td className={styles.cellValue}>{formatCurrency(item.total)}</td>
                <td className={styles.cellBar}>
                  <div className={styles.barTrack}>
                    <div
                      className={styles.barFill}
                      style={{ width: `${pct}%`, backgroundColor: color }}
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RankingTable;
